"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var hideable_1 = require("@pbl/pbl-react-web-components/lib/hideable");
var ActivityHistoryTab_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/history/ActivityHistoryTab"));
var DigitalGamesTab_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/history/DigitalGamesTab"));
var DrawHistoryTab_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/history/DrawHistoryTab"));
var EInstantHistoryTab_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/history/EInstantHistoryTab"));
var TicketHistoryDialog_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/history/TicketHistoryDialog"));
var TicketHistoryTab_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/history/TicketHistoryTab"));
var RewardHistoryTab_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/history/v2/RewardHistoryTab"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var RewardCouponModalV2_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/reward-detail/v2/RewardCouponModalV2"));
var ChipTabs_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/tabs/ChipTabs"));
var Title_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/title/Title"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../../config/constants"));
var actions_1 = require("../../../redux/reducers/loyalty/actions");
var AnalyticEvents_1 = __importDefault(require("../../../utils/AnalyticEvents"));
var filters_1 = require("../../../utils/filters");
var styles_2 = __importDefault(require("./styles"));
var perPageOptions = [10, 25, 50, 75, 100];
var getTabName = function (t, tabName) {
    var newtabName = tabName.toLowerCase();
    switch (newtabName) {
        case 'tickets':
            return t('history.ticketsTab');
        case 'promotions':
        case 'second_chance':
            return t('history.promotionsTab');
        case 'activity':
            return t('history.activities');
        case 'rewards':
        case 'reward':
            return t('history.rewards');
        case 'instants':
            return t('history.instants');
        case 'secondChanceGamesTab':
            return t('history.secondChanceGamesTab');
        default:
            return t('history.activities');
    }
};
var History = function (_a) {
    var _b;
    var identifier = _a.identifier, loading = _a.loading, historyTicketEntries = _a.historyTicketEntries, historyDraws = _a.historyDraws, HISTORY_ITEMS_PER_PAGE = _a.HISTORY_ITEMS_PER_PAGE, navigateToDrawDetails = _a.navigateToDrawDetails, setSelectedHistoryItem = _a.setSelectedHistoryItem, selectedHistoryItem = _a.selectedHistoryItem, _c = _a.showHeadingTitle, showHeadingTitle = _c === void 0 ? true : _c, _d = _a.showEInstant, showEInstant = _d === void 0 ? true : _d, showDigitalReveal = _a.showDigitalReveal, historyActivities = _a.historyActivities, historyRewards = _a.historyRewards, historyEInstants = _a.historyEInstants, reedemablePoints = _a.reedemablePoints, historyDigitalReveal = _a.historyDigitalReveal, isNewVersion = _a.isNewVersion, showEinstantTabFirst = _a.showEinstantTabFirst, pendingPoints = _a.pendingPoints, navigateToEInstantsHistoryDetails = _a.navigateToEInstantsHistoryDetails, refreshHistoryData = _a.refreshHistoryData, isTitleH1 = _a.isTitleH1, isAlternateHeadingStyle = _a.isAlternateHeadingStyle, showWinnerAnnouncementDateInsteadOfDrawDate = _a.showWinnerAnnouncementDateInsteadOfDrawDate;
    var theme = (0, styles_1.useTheme)();
    var isMobile = (0, core_1.useMediaQuery)(theme.breakpoints.down('sm'));
    var classes = (0, styles_2.default)(theme, isMobile)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var barcodeData = (0, react_redux_1.useSelector)(function (state) { return state.loyalty; }).barcodeData;
    var digitalRevealGame = (0, react_redux_1.useSelector)(function (state) { return state.interactiveGames; }).digitalRevealGame;
    var _e = react_1.default.useState({
        isOpenRedeemCouponDialog: false,
        openDialog: false,
        selectedRewardData: {}
    }), dialogState = _e[0], setDialogState = _e[1];
    var tabLabels = react_1.default.useMemo(function () { return ({
        ticket: t('history.ticketsTab'),
        promotions: t('history.promotionsTab'),
        activity: t('history.activities'),
        rewards: t('history.rewards'),
        eInstant: t('history.instants'),
        digitalGames: t('history.secondChanceGamesTab')
    }); }, [t]);
    var _f = react_1.default.useState(identifier ? getTabName(t, identifier) : getTabName(t, 'history.activities')), activeTab = _f[0], setActiveTab = _f[1];
    var isFirstRender = react_1.default.useRef(true);
    react_1.default.useEffect(function () {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (activeTab) {
            logAnalyticsEvent('AE0269', activeTab);
        }
    }, [activeTab]);
    var tabs = react_1.default.useMemo(function () {
        var baseTabs = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (!constants_1.default.SECOND_CHANCE_ONLY ? [tabLabels.activity, tabLabels.rewards] : []), true), [
            tabLabels.ticket,
            tabLabels.promotions
        ], false), (showDigitalReveal ? [tabLabels.digitalGames] : []), true), (showEInstant ? [tabLabels.eInstant] : []), true);
        return showEinstantTabFirst
            ? __spreadArray(__spreadArray(__spreadArray([
                tabLabels.activity,
                tabLabels.rewards,
                tabLabels.ticket
            ], (showEInstant ? [tabLabels.eInstant] : []), true), [
                tabLabels.promotions
            ], false), (showDigitalReveal ? [tabLabels.digitalGames] : []), true) : baseTabs;
    }, [showEinstantTabFirst, showDigitalReveal, showEInstant, tabLabels]);
    var filters = react_1.default.useMemo(function () {
        var _a, _b, _c, _d;
        switch (activeTab) {
            case tabLabels.ticket:
                return _a = {}, _a[filters_1.filterSections.DateFilterIndex] = historyTicketEntries.filter, _a;
            case tabLabels.promotions:
                return constants_1.default.REMOVE_SECOND_CHANCE_TAB_FILTER
                    ? null
                    : (_b = {}, _b[filters_1.filterSections.PromotionTypeFilterIndex] = historyDraws.filter, _b);
            case tabLabels.activity:
                return _c = {}, _c[filters_1.filterSections.DateFilterIndex] = historyActivities.filter, _c;
            case tabLabels.rewards:
                return _d = {}, _d[filters_1.filterSections.DateFilterIndex] = historyRewards.filter, _d;
            default:
                return null;
        }
    }, [activeTab, historyTicketEntries, historyDraws, historyActivities, historyRewards]);
    var setSelectedTicketEntry = react_1.default.useCallback(function (ticket) {
        setSelectedHistoryItem(ticket);
        setDialogState(function (prev) { return (__assign(__assign({}, prev), { openDialog: true })); });
    }, [setSelectedHistoryItem]);
    var closeDialog = react_1.default.useCallback(function () {
        setDialogState(function (prev) { return (__assign(__assign({}, prev), { openDialog: false })); });
    }, []);
    var onFilterDone = react_1.default.useCallback(function (updatedFilters) {
        if ([tabLabels.ticket, tabLabels.activity, tabLabels.rewards].includes(activeTab)) {
            historyTicketEntries.toggleFilter(updatedFilters);
            historyRewards.toggleFilter(updatedFilters);
            historyActivities.toggleFilter(updatedFilters);
        }
        if (activeTab === tabLabels.promotions && !constants_1.default.REMOVE_SECOND_CHANCE_TAB_FILTER) {
            historyDraws.toggleFilter(updatedFilters);
        }
    }, [activeTab, tabLabels, historyTicketEntries, historyRewards, historyActivities, historyDraws]);
    var onRemoveSelectedFilter = function (_entityName, sectionKey, filterKey) {
        if (sectionKey === filters_1.filterSections.DateFilterIndex) {
            historyTicketEntries.toggleFilter(filterKey, true);
            historyActivities.toggleFilter(filterKey, true);
            historyRewards.toggleFilter(filterKey, true);
            return;
        }
        if (sectionKey === filters_1.filterSections.PromotionTypeFilterIndex &&
            !constants_1.default.REMOVE_SECOND_CHANCE_TAB_FILTER) {
            historyDraws.toggleFilter(filterKey);
        }
    };
    var navigateToEInstantsDetails = react_1.default.useCallback(function (einstandGrouped, pageNumber) {
        navigateToEInstantsHistoryDetails === null || navigateToEInstantsHistoryDetails === void 0 ? void 0 : navigateToEInstantsHistoryDetails(einstandGrouped, pageNumber);
    }, [navigateToEInstantsHistoryDetails]);
    var getExtraData = react_1.default.useCallback(function (extra_data, key) {
        var _a;
        if (!extra_data)
            return '';
        var dataMap = new Map(extra_data.map(function (x) { return [x.key, x.value]; }));
        return (_a = dataMap.get(key)) !== null && _a !== void 0 ? _a : '';
    }, []);
    var navigateToViewAndDownloadBarcode = react_1.default.useCallback(function (reward) {
        if (!reward)
            return;
        var isCouponType = getExtraData(reward.extra_data, 'type').toLowerCase() === 'coupon';
        if (!isCouponType)
            return;
        var key = getExtraData(reward.extra_data, 'key');
        var humanReadable = getExtraData(reward.extra_data, 'humanReadable');
        var code = getExtraData(reward.extra_data, 'code');
        if (key) {
            dispatch((0, actions_1.getBarcodeData)(key, code, humanReadable));
            setDialogState(function (prev) { return (__assign(__assign({}, prev), { selectedRewardData: reward, isOpenRedeemCouponDialog: true })); });
        }
    }, [dispatch, getExtraData]);
    var hideRedeemCouponCodeModal = react_1.default.useCallback(function () {
        setDialogState(function (prev) { return (__assign(__assign({}, prev), { isOpenRedeemCouponDialog: false })); });
    }, []);
    var getPointsBalanceVariant = react_1.default.useCallback(function () {
        return isNewVersion ? (isMobile ? 'h4' : 'h3') : 'h6';
    }, [isNewVersion, isMobile]);
    var handleEndGame = function (digitalRevealToken) {
        if (!digitalRevealToken)
            return;
        historyDigitalReveal.endDigitalGame(digitalRevealToken).then(function () {
            refreshHistoryData();
        });
    };
    var logAnalyticsEvent = function (eventCode, eventLabel) {
        var _a;
        var event = (_a = window === null || window === void 0 ? void 0 : window.analyticsEventMapping) === null || _a === void 0 ? void 0 : _a[eventCode];
        if (!event)
            return;
        AnalyticEvents_1.default.logEvent(eventCode, __assign(__assign({}, event), { eventCategory: event.eventCategory, eventAction: event.eventAction, eventLabel: eventLabel }));
    };
    var handleFilterIconClick = function () {
        logAnalyticsEvent('AE0270', 'Filter History');
    };
    var handleRowPerPageChange = function (size) {
        logAnalyticsEvent('AE0271', 'Entries Per Page');
    };
    var handlePrevPageClick = function () {
        logAnalyticsEvent('AE0272', 'Prev');
    };
    var handleNextPageClick = function () {
        var _a;
        var event = (_a = window === null || window === void 0 ? void 0 : window.analyticsEventMapping) === null || _a === void 0 ? void 0 : _a['AE0273'];
        logAnalyticsEvent('AE0273', 'Next');
    };
    var handlePageNumberClick = function (index) {
        logAnalyticsEvent('AE0274', "".concat(index));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        dialogState.openDialog && selectedHistoryItem && (react_1.default.createElement(TicketHistoryDialog_1.default, { ticket: selectedHistoryItem, classes: classes, openDialog: dialogState.openDialog, handleClose: closeDialog })),
        react_1.default.createElement(hideable_1.Hideable, { show: Boolean(dialogState.selectedRewardData && dialogState.isOpenRedeemCouponDialog && barcodeData) },
            react_1.default.createElement(RewardCouponModalV2_1.default, { open: true, barcodeData: barcodeData, selectedReward: dialogState.selectedRewardData || '', historyReward: dialogState.selectedRewardData || '', onClose: hideRedeemCouponCodeModal })),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
            loading && (react_1.default.createElement(package_1.AppSpinner, { label: 'Loading History', customStyles: {
                    backgroundColor: 'transparent'
                } })),
            showHeadingTitle && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                !isNewVersion && (react_1.default.createElement(Title_1.default, { title: t('history.title'), titleColor: 'textPrimary', isTitleH1: isTitleH1, isAlternateHeadingStyle: isAlternateHeadingStyle })),
                react_1.default.createElement(core_1.Typography, { variant: getPointsBalanceVariant(), gutterBottom: true, color: 'textPrimary', component: 'span', className: pendingPoints && pendingPoints > 0 ? classes.showFlexForPendingPoints : undefined },
                    "Points Balance : ",
                    reedemablePoints.toLocaleString('en-US'),
                    pendingPoints && pendingPoints > 0 && constants_1.default.SHOW_PENDING_POINTS_ON_HISTORY_PAGE && (react_1.default.createElement("div", { className: classes.pendingTotalPoints },
                        react_1.default.createElement(core_1.Typography, { variant: "subtitle2", gutterBottom: true, color: 'error', component: 'span', className: classes.pendingPoints },
                            "Pending Points: ",
                            pendingPoints.toPointsFormat()),
                        ' ',
                        react_1.default.createElement(core_1.Tooltip, { title: "".concat(t('history.pendingPoints')), "aria-label": "".concat(t('history.pendingPoints')), placement: 'top' },
                            react_1.default.createElement(core_1.Icon, { color: "action", fontSize: "small", className: classes.pendingPoints }, "help-circle"))))))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: (0, classnames_1.default)(classes.tabSection, classes.noBottomSpacing) },
                react_1.default.createElement(ChipTabs_1.default, { collapsible: true, tabs: tabs, selectTab: setActiveTab, selectedTab: activeTab }),
                filters && (react_1.default.createElement(package_1.FilterSection, { entityName: "history", title: 'Filter History', filterTitle: 'Filter History', filters: filters, onOk: onFilterDone, onRemoveSelected: onRemoveSelectedFilter, onlyFilter: true, onIconClick: handleFilterIconClick }))),
            filters && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: (0, classnames_1.default)(classes.noBottomSpacing, classes.noTopSpacing, classes.selectedFilter) }, filters && (react_1.default.createElement(package_1.SelectedFiltersSection, { filters: filters, entityName: "history", onRemoveSelected: onRemoveSelectedFilter })))),
            activeTab === tabLabels.ticket && (react_1.default.createElement(TicketHistoryTab_1.default, { tickets: historyTicketEntries.data, loading: historyDraws.loading, dispatchFetchPage: historyTicketEntries.getTicketsData, page: historyTicketEntries.page, setSelectedTicketEntry: setSelectedTicketEntry, HISTORY_ITEMS_PER_PAGE: HISTORY_ITEMS_PER_PAGE, shouldShowGameId: (_b = constants_1.default.SHOULD_NOT_SHOW_GAME_ID) !== null && _b !== void 0 ? _b : true, onNextPageClick: handleNextPageClick, onPrevPageClick: handlePrevPageClick, onPageNumberClick: handlePageNumberClick })),
            activeTab === tabLabels.promotions && (react_1.default.createElement(DrawHistoryTab_1.default, { draws: historyDraws.data, loading: historyDraws.loading, dispatchFetchPage: historyDraws.fetchData, page: historyDraws.page, navigateToDrawDetails: navigateToDrawDetails, HISTORY_ITEMS_PER_PAGE: HISTORY_ITEMS_PER_PAGE, showWinnerAnnouncementDateInsteadOfDrawDate: showWinnerAnnouncementDateInsteadOfDrawDate })),
            activeTab === tabLabels.activity && (react_1.default.createElement(ActivityHistoryTab_1.default, { activities: historyActivities.data, loading: false, errorMessage: null, dispatchFetchPage: historyActivities.fetchData, onRowsPerPageChange: handleRowPerPageChange, page: historyActivities.page, DEFAULT_ACTIVITIES_PER_PAGE: HISTORY_ITEMS_PER_PAGE, perPageOptions: perPageOptions, showPastHistoryFeature: historyActivities.showPastHistoryFeature && historyActivities.isLegacyUser, topPaginationDisplayPageNumbers: !isMobile, topPaginationDisplayRowsPerPageDropdownInFullWidth: isMobile, bottomPaginationDisplayRowsPerPageDropdownFullWidth: isMobile, topPaginationWrapperStyle: isMobile
                    ? {
                        justifyContent: 'flex-end'
                    }
                    : {}, bottomPaginationWrapperStyle: isMobile
                    ? {
                        flexDirection: 'column',
                        alignItems: 'center'
                    }
                    : {}, onNextPageClick: handleNextPageClick, onPrevPageClick: handlePrevPageClick, onPageNumberClick: handlePageNumberClick })),
            activeTab === tabLabels.rewards && (react_1.default.createElement(RewardHistoryTab_1.default, { rewards: historyRewards.data, loading: historyRewards.loading, errorMessage: null, hidePagination: historyRewards.hidePagination, dispatchFetchPage: historyRewards.fetchData, onRowsPerPageChange: handleRowPerPageChange, page: historyRewards.page, HISTORY_ITEMS_PER_PAGE: HISTORY_ITEMS_PER_PAGE, navigateToViewAndDownloadBarcode: navigateToViewAndDownloadBarcode, drawEntriesOnly: !!historyRewards.drawEntriesOnly, showRewardEntries: !!historyRewards.showRewardEntries, perPageOptions: perPageOptions, showPastHistoryFeature: historyRewards.showPastHistoryFeature && historyRewards.isLegacyUser, onNextPageClick: handleNextPageClick, onPrevPageClick: handlePrevPageClick, onPageNumberClick: handlePageNumberClick })),
            showDigitalReveal && activeTab === tabLabels.digitalGames && (react_1.default.createElement(DigitalGamesTab_1.default, { games: historyDigitalReveal.data, page: historyDigitalReveal.page, loading: loading, dispatchFetchPage: historyDigitalReveal.fetchData, onStartGame: historyDigitalReveal.startDigitalGame, sgiGameUrl: digitalRevealGame, onEndGame: !constants_1.default.REFRESH_HISTORY_DATA_AFTER_GAMEPLAY
                    ? historyDigitalReveal.endDigitalGame
                    : handleEndGame, HISTORY_ITEMS_PER_PAGE: HISTORY_ITEMS_PER_PAGE, onNextPageClick: handleNextPageClick, onPrevPageClick: handlePrevPageClick, onPageNumberClick: handlePageNumberClick })),
            showEInstant && activeTab === tabLabels.eInstant && (react_1.default.createElement(EInstantHistoryTab_1.default, { historyEInstantsGrouped: historyEInstants.data, loading: historyEInstants.loading, dispatchFetchPage: historyEInstants.fetchData, page: historyEInstants.page, navigateToEInstantsHistoryDetails: navigateToEInstantsDetails, HISTORY_ITEMS_PER_PAGE: HISTORY_ITEMS_PER_PAGE, onNextPageClick: handleNextPageClick, onPrevPageClick: handlePrevPageClick, onPageNumberClick: handlePageNumberClick })))));
};
exports.default = History;
//# sourceMappingURL=History.js.map